import { createFileRoute } from '@tanstack/react-router'
import { SettingsScreen } from '../features/settings/SettingsScreen'

function Settings() {
  const { workspaceId } = Route.useParams()
  return <SettingsScreen workspaceId={workspaceId} />
}

export const Route = createFileRoute('/w/$workspaceId/settings')({ component: Settings })
